// The table of the settlement summary's party cards (Step4Summary): the
// header cells are DataTable's own (Cell header), the body cells these.
import styled from "styled-components";
import { CELL_PADDING } from "./provisionColumns";

// The amounts end on the right edge, the unit's share and the occupied days
// sit in the middle of their columns (Lewis, 2026-10-18).
export type TColumnAlign = "left" | "center" | "right";

export const HEADER_CONTENT_TYPE: Record<
  TColumnAlign,
  "text" | "text-centered" | "numeric"
> = {
  left: "text",
  center: "text-centered",
  right: "numeric",
};

export const SummaryTable = styled.table`
  width: 100%;
  border-spacing: 0;
  table-layout: fixed;
  /* A word or a date is never split over two lines ("16/10/202 6"). */
  th,
  td,
  th *,
  td * {
    word-break: normal;
    overflow-wrap: normal;
  }
  .nowrap {
    white-space: nowrap;
  }
  /* The totals below draw their own line: the last row's would make it a
     double one (Lewis, 2026-10-19). */
  tbody tr:last-child > td {
    border-bottom: 0;
  }
`;

export const BodyCell = styled.td<{ align?: TColumnAlign }>`
  padding: 10px ${CELL_PADDING};
  vertical-align: top;
  line-height: 1.3;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral20};
  text-align: ${({ align }) => align ?? "left"};
  ${({ align }) => (align === "right" ? "white-space: nowrap;" : "")}
`;

// The width of the totals' amounts: as wide as the table's amount column
// at its narrowest, so the amounts end on one edge.
const TOTAL_AMOUNT_WIDTH = 120;
// The slot for a total's "i", after its label.
const INFO_SLOT_WIDTH = 22;

// The totals under a card's table (the summary's): each label
// right-aligned to one edge, its "i" in a slot of its own after that edge,
// then the amount.
export const CardTotalLines = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) ${INFO_SLOT_WIDTH}px ${TOTAL_AMOUNT_WIDTH}px;
  row-gap: 8px;
  align-items: baseline;
  .total-label {
    text-align: right;
  }
  .total-info {
    display: flex;
    justify-content: flex-start;
  }
  .total-amount {
    text-align: right;
    white-space: nowrap;
  }
`;
